<template>
	<div class="item" :class="{'item--lock': (!dataSource.isShowFree || dataSource.isShowFree === 0) && !dataSource.isActived}">
		<div class="item__wrap">
			<a 
				class="item__head aspect-ratio aspect-ratio--16-9 text-center border-rd-4 bg-transparent" 
				:class="{'aspect-audio': dataSource.linkUrl && checkAudio(dataSource.linkUrl)}" href="javascript:;" 
				@click="onClickItem((dataSource.linkUrl && checkAudio(dataSource.linkUrl))?'audio':(dataSource.linkUrl && checkVideo(dataSource.linkUrl))?'video':(dataSource.linkUrl && checkGifImage(dataSource.linkUrl))?'gif':(dataSource.linkUrl && checkImage(dataSource.linkUrl))?'image':'')"
				
			>
				<div class="img__wrap" v-if="dataSource.imageUrl">
					<img :src="dataSource.imageUrl ? handleResizeImg(dataSource.imageUrl) : img404" :alt="dataSource.title">
				</div>
				<template v-else-if="dataSource.linkUrl && checkVideo(dataSource.linkUrl)"><!--  || checkAudio(dataSource.linkUrl) -->
					<div class="img__wrap"><!-- v-if="dataSource.posterLink" -->
						<img :src="dataSource.posterLink ? handleResizeImg(dataSource.posterLink) : img404" :alt="dataSource.title">
					</div>
				</template>
				<PreviewImage 
					v-else-if="dataSource.linkUrl && checkGifImage(dataSource.linkUrl)" 
					:pathView="isFullLink(dataSource.linkUrl) ? dataSource.linkUrl : `${appUrl}${dataSource.linkUrl}`" 
				/>
				<PreviewImage 
					v-else-if="dataSource.linkUrl && checkImage(dataSource.linkUrl)" 
					:pathView="isFullLink(dataSource.linkUrl) ? dataSource.linkUrl : handleResizeImg(dataSource.linkUrl)" 
				/>
				<PreviewYoutube 
					v-else-if="dataSource.linkUrl && checkYoutube(dataSource.linkUrl)" 
					:pathView="dataSource.linkUrl"
				/>
				<!-- <template v-else-if="dataSource.linkUrl && checkAudio(dataSource.linkUrl)"> -->
					<!-- <div class="img__wrap">
						<img :src="dataSource.posterLink ? `${urlImg}/${dataSource.posterLink}` : img404" :alt="dataSource.title">
					</div> -->
				<div class="img-wrap text-center full-width" v-else-if="dataSource.linkUrl && checkAudio(dataSource.linkUrl)" :class="{'evt-none': !isPlay}">
					<audio
					:id="`audio_${dataSource.pagelinksId}`"
					:src="isFullLink(dataSource.linkUrl) ? dataSource.linkUrl : `${appUrl}${dataSource.linkUrl}`"
					controls
					controlsList="nodownload"
					class="full-width"
					></audio>
				</div>
				<!-- </template> -->
				<IconMedia 
				class="item__icon"
				v-if="isLesson !== 2"
				:dataSource="dataSource"
				:position="position"
				:isPlay="isPlay"
				:class="{'evt-none': !isPlay || ((!dataSource.isShowFree || dataSource.isShowFree === 0) && !dataSource.isActived)}"
				/>
			</a>
			
			<div class="item__body" @click="onClickItem((dataSource.linkUrl && checkAudio(dataSource.linkUrl))?'audio':(dataSource.linkUrl && checkVideo(dataSource.linkUrl))?'video':(dataSource.linkUrl && checkGifImage(dataSource.linkUrl))?'gif':(dataSource.linkUrl && checkImage(dataSource.linkUrl))?'image':'')">
				<p class="item__excerpt font-size-15 secondary-color-txt margin-0 font-sanpro-light">
					{{ dataSource.titlelink }}
				</p>
				
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex'
	import { APP_CONFIG } from '@/utils/constants'
	import mixinsFiles from '@/components/content-files/mixinsFiles'
	import PreviewImage from '@/components/content-files/PreviewImage.vue'
	import PreviewYoutube from '@/components/content-files/PreviewYoutube.vue'
	import PreviewAudio from '@/components/content-files/PreviewAudio.vue'
	import { getAuth } from '@/utils/jwt'
	import { EMAIL_PUBLIC } from '@/store/auth/constants'
	import IconMedia from './IconMedia.vue'
	import { STORE_KEY } from "../../_store/constants"
	import { replaceImageResize } from '@/helpers/functions'
	const img404 = require(`@/assets/images/img_404.jpg`)

	export default {
		name: 'ItemLibrary',
		mixins: [ mixinsFiles ],
		components: {
			PreviewImage,
			PreviewYoutube,
			PreviewAudio,
      		IconMedia
		},
		props: {
			dataSource: Object,
			isLesson: Number,
			isPlay: Boolean,
			position: Number
		},
		data () {
			return {
				urlImg: APP_CONFIG.urlPlatformCmsImg,
				appUrl: APP_CONFIG.bookCdnUrl,
				img404,
        		audioPause: -1
			}
		},
		computed: {
			...mapState('auth', ['loginPopupData']),
      		...mapState(STORE_KEY, ['resultBookPageLinkFilter', 'resultBookLessonFilter', 'paramFilterBook', 'paramFilterBookLesson'])
		},
		methods: {
			onClickItem(type){
				console.log(type)
				if(type == 'audio'){
					let el= document.getElementById(`audio_${this.dataSource.pagelinksId}`)
					if(el.paused){
						el.play()
					}else{
						el.pause()
					}
				}
				else if(type == 'video'){
					this.$emit('onViewItem',{type:'video',pagelinksId:this.dataSource.pagelinksId})
				}
				else if(type == 'gif'){
					this.$emit('onViewItem',{type:'gif',pagelinksId:this.dataSource.pagelinksId})
				}
				else if(type == 'image'){
					this.$emit('onViewItem',{type:'image',pagelinksId:this.dataSource.pagelinksId})
				}
			},
			setTypeIcon (val) {
				if ( (!val.isShowFree || val.isShowFree === 0) && !val.isActived ) {
				return '-3'
				} else if (val.isActived && !val.isPublish) {
				return '-2'
				} else {
				return ''
				}
			},

			handleResizeImg (link) {
				return replaceImageResize(link, {width: 340, height: 192})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "./../../../../assets/scss/_variables";
	@import "./../../../../assets/scss/_mixins";
	@import "./../../../../assets/scss/general";
	
	.count-view{
		// position: absolute;
		// top: 53%;
		// left: 9%;
		// display: none;
		.count-v{
			// padding-left: 5px;
		}
	}

	.view-audio {
		pointer-events: none;
	}

	.item {
		margin-bottom: 30px;
		overflow: hidden;

		&--lock {
		.item {
			&__title {
			@extend .secondary-color-txt;
			}
		}
		}

		// &--lock {
  		//.item {
        &__head:after {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(0,0,0,.3);
          @extend .effect-transition-fast;
          @extend .effect-hide-hover;
        }

		//   &__icon {
		//     opacity: 1;
		//   }
		// }
			// opacity: .7;
			// pointer-events: none;
		// }

		&__wrap {
			max-width: 340px;
			margin: 0 auto;
		}

		&__head {
			&.aspect-audio {
				&:before {
				padding-top: 30%;
				}
			}
			audio, video {
				width: 100%;
			}
		}

		&__icon {
			opacity: 0;
			z-index: 2;
		}

		&__body {
			padding: 8px 0;
		}

		&__title {
			margin-bottom: 4px;

			a {
				color: inherit;
			}
		}

		video, audio {
			width: 100%;
			pointer-events: none;
		}

		&:hover {
			&:not(.item--lock) {
				.item {
					&__title {
						@extend .primary-color;
					}
				}
			}
			.item {
				&__head {
					&:after {
						@extend .effect-show-hover;
					}
				}

				&__icon {
					opacity: 1;
				}
			}
			.count-view{
				// display: block;
			}
			// @media screen and ( max-width: 575px ) {
			// 	&:not(.item--lock) {
			// 		.item {
			// 			&__title {
			// 				// @extend .primary-color;
			// 			}
			// 		}
			// 	}
			// 	.item {
			// 		&__head {
			// 			&:after {
			// 				// @extend .effect-show-hover;
			// 			}
			// 		}

			// 		&__icon {
			// 			opacity: 1;
			// 		}
			// 	}
			// }
		}

		@media screen and ( max-width: 767px ) {
			&__head {
				height: auto;
				min-height: 110px;
			}
		}
		
	}
</style>